"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8540],{

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 86713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ formComponent; }
/* harmony export */ });
var formComponent = {
    button_text: "Submit",
    errors: {
        field_required: "This field is required!",
        incorrect_mail: "This email address is incorrect."
    },
    form: {
        consent: {
            beginning: "I agree to ",
            link1_text: "Terms and Conditions",
            link1_url: "/terms-and-conditions",
            separator: " and ",
            link2_text: "Privacy Policy",
            link2_url: "/privacy-policy"
        },
        button_text: "Submit"
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 67534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ validate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86713);


var flattenDataArray = function(data) {
    var newData = {
        fields: []
    };
    data.fields.forEach(function(field) {
        if (field.component !== "standard-multielement") {
            newData.fields.push(field);
        } else {
            var _fields;
            (_fields = newData.fields).push.apply(_fields, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(field.fields));
        }
    });
    return newData;
};
var validate = function(param) {
    var type = param.type, formData = param.formData, data = param.data, changeErrors = param.changeErrors, consent = param.consent;
    var newErrors = setErrors({
        type: type,
        formData: formData,
        data: flattenDataArray(data),
        consent: consent
    });
    changeErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
        return true;
    } else {
        scrollToError(newErrors);
        return false;
    }
};
var setErrors = function(param) {
    var type = param.type, formData = param.formData, data = param.data, consent = param.consent;
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var newErrors = {};
    if (type === "DSAR" && formData.is_data_subject !== data.fields.filter(function(field) {
        return field.id === "is_data_subject";
    })[0].options[1]) {
        data.fields.filter(function(field) {
            return field.required === true && field.id.substring(0, 8).indexOf("detail_") === -1;
        }).forEach(function(field) {
            if (formData[field.id].length === 0) newErrors[field.id] = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
            if (formData.email.length !== 0 && !regex.test(String(formData.email).toLowerCase())) newErrors.email = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
        });
    } else {
        data.fields.filter(function(field) {
            return field.required === true;
        }).forEach(function(field) {
            var ref, ref1;
            if (formData[field.id].length === 0) newErrors[field.id] = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
            if (typeof formData.email !== "undefined" && ((ref = formData.email) === null || ref === void 0 ? void 0 : ref.length) !== 0 && !regex.test(String(formData.email).toLowerCase())) newErrors.email = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
            if (typeof formData.email_bottom !== "undefined" && ((ref1 = formData.email_bottom) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0 && !regex.test(String(formData.email_bottom).toLowerCase())) newErrors.email_bottom = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
        });
    }
    if (typeof consent !== "undefined" && consent === false) newErrors.consent = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
    return newErrors;
};
var scrollToError = function(errorsObject) {
    var _Math;
    var errorLabels = [];
    errorLabels = Object.keys(errorsObject);
    var scrollTop = window.pageYOffset;
    var positions = [];
    errorLabels.forEach(function(label) {
        var element = document.getElementById("standard-".concat(label));
        if (typeof element === "undefined") element = document.getElementById("retractible-".concat(label));
        if (label === "consent") element = document.getElementById("consent");
        var rect = element.getBoundingClientRect();
        var position = rect.top;
        positions.push(position);
    });
    window.scroll({
        top: (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(positions)) + scrollTop - 170,
        left: 0,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 24606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ StandardField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/Radio.jsx

var Radio = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "radio-main",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: "radio-label",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "radio-text",
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    value: text,
                    checked: checked,
                    onChange: function(e) {
                        return onChange(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "radio-box"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/components/form/SingleChoice.jsx


var SingleChoice = function(param) {
    var label = param.label, checked = param.checked, onChange = param.onChange, options = param.options, error = param.error, required = param.required;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "single_choice-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "single_choice-label",
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                    text: option,
                    checked: checked === option,
                    onChange: onChange
                }, option);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "single_choice-error",
                children: error
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/Box.jsx

var Box = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "box-main",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: "box-label",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "box-text",
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    value: text,
                    checked: checked,
                    onChange: function(e) {
                        return onChange(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "box-box"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/components/form/MultipleChoice.jsx



var MultipleChoice = function(param) {
    var label = param.label, array = param.array, onChange = param.onChange, options = param.options, required = param.required, error = param.error;
    var changeArray = function(value) {
        var newArray = (0,_to_consumable_array/* default */.Z)(array);
        if (array.indexOf(value) === -1) {
            newArray.push(value);
            onChange(newArray);
        } else {
            var returnArray = newArray.filter(function(item) {
                return item !== value;
            });
            onChange(returnArray);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "multiple_choice-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "multiple_choice-label",
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                    text: option,
                    checked: array.indexOf(option) !== -1,
                    onChange: changeArray
                }, option);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "multiple_choice-error",
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/components/form/Input.jsx

var Input = function(param) {
    var value = param.value, onChange = param.onChange, label = param.label, required = param.required, placeholder = param.placeholder, error = param.error, type = param.type, _labelClassName = param.labelClassName, labelClassName = _labelClassName === void 0 ? "input-label" : _labelClassName, _className = param.className, className = _className === void 0 ? "" : _className, _hideRequiredLabel = param.hideRequiredLabel, hideRequiredLabel = _hideRequiredLabel === void 0 ? false : _hideRequiredLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "input-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: labelClassName,
                htmlFor: label,
                children: [
                    label,
                    hideRequiredLabel === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: label,
                name: label,
                className: "input-proper ".concat(error ? "error" : "", " ").concat(className ? className : ""),
                value: value,
                placeholder: placeholder,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                type: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "input-error",
                children: error
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/views/components/form/Textarea.jsx
var Textarea = __webpack_require__(55746);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/Datepicker.jsx

var Datepicker = function(param) {
    var value = param.value, onChange = param.onChange, label = param.label, required = param.required, error = param.error, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "datepicker-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "datepicker-label",
                htmlFor: label,
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: label,
                name: label,
                className: "datepicker-proper ".concat(error ? "error" : ""),
                value: value,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                type: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "datepicker-error",
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/components/form/Select.jsx

var Select = function(param) {
    var label = param.label, options = param.options, onChange = param.onChange, required = param.required, error = param.error, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "select-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "select-label",
                htmlFor: label,
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                name: label,
                id: label,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                className: "select-proper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "",
                        children: placeholder
                    }),
                    options.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: option.abbreviation,
                            children: option.name
                        }, option.abbreviation);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "select-error",
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx







var StandardField = function(param) {
    var fields = param.fields, formData = param.formData, changeData = param.changeData, errors = param.errors, _labelClassName = param.labelClassName, labelClassName = _labelClassName === void 0 ? "input-label" : _labelClassName, _className = param.className, className = _className === void 0 ? "" : _className, _classNameTextArea = param.classNameTextArea, classNameTextArea = _classNameTextArea === void 0 ? "" : _classNameTextArea, _hideRequiredLabel = param.hideRequiredLabel, hideRequiredLabel = _hideRequiredLabel === void 0 ? false : _hideRequiredLabel;
    return fields.map(function(field, fieldIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: "standard-".concat(field.id)
                }),
                field.component === "standard-multielement" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "standard-multielement",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField, {
                        fields: field.fields,
                        formData: formData,
                        changeData: changeData,
                        errors: errors
                    })
                }),
                field.component === "input" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    value: formData[field.id],
                    label: field.label,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    error: errors[field.id],
                    type: field.type,
                    required: field.required,
                    labelClassName: labelClassName,
                    placeholder: field.placeholder,
                    className: className,
                    hideRequiredLabel: hideRequiredLabel
                }),
                field.component === "datepicker" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Datepicker, {
                    value: formData[field.id],
                    label: field.label,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    type: field.type,
                    error: errors[field.id],
                    required: field.required
                }),
                field.component === "textarea" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* Textarea */.g, {
                    value: formData[field.id],
                    label: field.label,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    error: errors[field.id],
                    required: field.required,
                    placeholder: field.placeholder,
                    labelClassName: labelClassName,
                    className: classNameTextArea
                }),
                field.component === "singlechoice" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleChoice, {
                    label: field.label,
                    options: field.options,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    error: errors[field.id],
                    required: field.required,
                    checked: formData[field.id]
                }),
                field.component === "multiplechoice" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleChoice, {
                    label: field.label,
                    options: field.options,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    error: errors[field.id],
                    required: field.required,
                    array: formData[field.id]
                }),
                field.component === "select" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                    label: field.label,
                    options: field.options,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    placeholder: field.placeholder,
                    error: errors[field.id],
                    required: field.required
                })
            ]
        }, fieldIndex);
    });
};


/***/ }),

/***/ 88749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65966);






var Button = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, onClick = _param.onClick, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "children",
        "variant",
        "size",
        "disabled",
        "onClick",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        onClick: function(e) {
            return onClick && onClick(e);
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), className),
        disabled: disabled
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }),
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 55746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Textarea = function(param) {
    var value = param.value, onChange = param.onChange, label = param.label, required = param.required, error = param.error, placeholder = param.placeholder, _labelClassName = param.labelClassName, labelClassName = _labelClassName === void 0 ? "textarea-label" : _labelClassName, _className = param.className, className = _className === void 0 ? "textarea-proper" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "textarea-main",
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: labelClassName,
                htmlFor: label,
                children: [
                    label,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: required ? "Required" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                id: label,
                name: label,
                className: "".concat(className === "" ? "textarea-proper" : className, " ").concat(error ? "error" : ""),
                value: value,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                placeholder: placeholder
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "textarea-error",
                children: error
            })
        ]
    });
};


/***/ })

}]);